import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subscription, distinctUntilChanged, filter } from "rxjs";
import { v4 } from "uuid";

import {
    ComparisonTable,
    MeasurementSystem,
    MeasurementSystemSizeComparisonTable,
    MeasureYourselfTable,
} from "@hermes/api-model-product";

import { UnitTypeService } from "../../services/unit-type.service";

@Component({
    selector: "h-block-table",
    templateUrl: "./block-table.component.html",
    styleUrl: "./block-table.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockTableComponent implements OnInit, OnChanges, OnDestroy {
    @Input({ required: true })
    public content!:
        | MeasurementSystemSizeComparisonTable
        | Partial<MeasureYourselfTable>;

    public subscription: Subscription = new Subscription();

    public currentContent!: ComparisonTable | undefined;

    public labelInt: string = "cm";
    public labelImp: string = "inches";

    public selectedUnitForm: FormGroup = this.fb.group({
        unitTypeControl: undefined,
    });

    public uuidForm = v4();

    constructor(
        private fb: FormBuilder,
        private unitTypeService: UnitTypeService,
        private cdr: ChangeDetectorRef,
    ) {}

    public ngOnInit() {
        this.subscription.add(
            this.unitTypeService.selectedUnit$
                .pipe(
                    distinctUntilChanged(),
                    filter(
                        (unit) =>
                            unit !==
                            this.selectedUnitForm.get("unitTypeControl")?.value,
                    ),
                )
                .subscribe((unit) => {
                    this.selectedUnitForm.patchValue({ unitTypeControl: unit });
                    this.setTableCurrentContent(unit);
                    this.cdr.detectChanges();
                }),
        );
        this.onUnitTypeChangeInForm();
    }

    public ngOnChanges(_changes: SimpleChanges): void {
        this.setTableCurrentContent(
            this.selectedUnitForm.get("unitTypeControl")?.value,
        );
    }

    public setTableCurrentContent(unit: MeasurementSystem): void {
        this.currentContent = this.content[unit];
        this.labelInt = this.content["international"]?.label || "cm";
        this.labelImp = this.content["imperial"]?.label || "inches";
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private onUnitTypeChangeInForm() {
        const unitTypeControl = this.selectedUnitForm.get("unitTypeControl");
        if (unitTypeControl) {
            this.subscription.add(
                unitTypeControl.valueChanges
                    .pipe(filter(Boolean))
                    .subscribe((selectedValue: MeasurementSystem) => {
                        this.unitTypeService.selectedUnit$.next(selectedValue);
                        this.setTableCurrentContent(selectedValue);
                    }),
            );
        }
    }
}
